export const isDevelopment = process.env.NODE_ENV === 'development';
export const baseUrl = process.env.REACT_APP_PUBLIC_HTTP_BASE_URL || '';
export const fallbackLanguage = process.env.REACT_APP_FALLBACK_LANG;
export const applicationVersion = process.env.REACT_APP_VERSION;
